<!-- @format -->

@if (enrolmentRight?.courseUnitId | courseUnit | async; as courseUnit) {
  <sis-expandable
    [variant]="'naked-dotted'"
    [level]="6"
    [title]="courseUnit.code + ' ' + (courseUnit.name | localizedString)"
    [attr.data-cy]="'open-university-enrolment-right-title'">
    <ng-template sisExpandableCustomTitle>
      <sis-enrolment-right-badges [enrolmentRight]="enrolmentRight" />
    </ng-template>
    <ng-template sisExpandableHeaderButtons>
      @if (componentType === "STAFF" && enrolmentRight?.type !== "SUBSTITUTION") {
        <sis-menu-button
          [options]="menuOptions"
          [attr.data-cy]="'open-university-enrolment-right-menu-button'"
          (click)="$event.preventDefault(); $event.stopPropagation()" />
      }
    </ng-template>
    <ng-template sisExpandableContent>
      <sis-enrolment-right-expandable-body [enrolmentRight]="enrolmentRight" [componentType]="componentType" />
    </ng-template>
  </sis-expandable>
}
